import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Dashboard from './components/Dashboard';
import { chartIcons } from './mock';
import { Compare } from './components/Compare';
import moment, { relativeTimeThreshold } from 'moment';
import { toast } from 'react-toastify';
import * as FileSaver from 'file-saver';
import {withFirebase} from '../../Firebase';
import FacebookConnect from '../shared-components/FacebookConnect/FacebookConnect';
import {
  UNIMPLEMENTED_CHART_IDS,
  CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE,
  ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE,
  DEFAULT_POST_SORT_TYPE_VALUE,
  DEFAULT_COMMENT_SORT_TYPE_VALUE,
  POST_SORT_STATE_TO_VALUE_MAP,
  COMMENT_SORT_STATE_TO_VALUE_MAP,
  UPDATING_SOURCES_MSG,
  FACEBOOK_LOGIN_WARNING_TITLE,
  FACEBOOK_LOGIN_WARNING_MSG,
  NO_SPECIFIC_EMOTION,
  NEUTRAL,
  MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE,
  SARCASM_LABEL_UPDATED_MESSAGE,
  SARCASM_LABEL_NOT_UPDATED_MESSAGE,
  SARCASM_POST_COUNT_UPDATE_ERROR_MESSAGE,
  VALUE_KEY
} from './redux/constants';
import { 
  CHARTS_WHICH_NEED_ADJUSTMENT_FOR_SARCASM, 
  CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE,
  MONTH_UNIT,
  DAY_UNIT,
  HOUR_UNIT,
  MAXIMUM_NUMBER_OF_DAYS_FOR_DAILY_TREND_CHARTS
} from '../shared-components/chart/redux/constants';
import {
  FACEBOOK_CONNECTION_SUCCESS_MSG
} from '../sources/redux/constants';
import {
  RELEVANCE_UPDATE_SUCCESSFUL_TOAST_MESSAGE,
  RELEVANCE_UPDATE_FAILURE_TOAST_MESSAGE,
  CHARTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE,
  POST_COUNTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE
} from './constants/DisplayedTextConstants';
import { DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT } from '../shared-components/chart/constants/eventLabellingChartConstants';
import ReactGA from 'react-ga';
import { GaContext } from '../../googleAnalyticsContext/GaContext';
import NoTopic from '../shared-components/no-topic';
import { getUserEmailFromLocalStorage } from '../../Firebase/localStorageForUserInfo';
import { getLoginRedirectUrl } from './sharedFunctions';
import { RELEVANT_OPTION_VALUE } from './components/comment-filter/constants/RelevanceFilterConstants';

const PAGE_LIMIT = 10;
const DATE_RANGE_FOR_AGGREGATION = 180;
export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    activeTopicCompareData: {},
    topicCompareData: [],
    topicDropdown: {},
    allCategories: [],
    availableCharts: [],
    selectedTopicID: [],
    comments: { data: {}, count: null },
    uploadedComments: { data: {}, count: null },
    commentsFeedsFilterDate: {
      fromDate: moment()
        .subtract(6, 'days')
        .format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
    },
    postSortType: DEFAULT_POST_SORT_TYPE_VALUE,
    commentSortType: DEFAULT_COMMENT_SORT_TYPE_VALUE,
    uploadedCommentsSortType: DEFAULT_COMMENT_SORT_TYPE_VALUE,
    tweetSortType: DEFAULT_COMMENT_SORT_TYPE_VALUE,
    currentCommentsPage: 1,
    currentUploadedCommentsPage: 1,
    currentFeedsPage: 1,
    currentTweetsPage: 1,
    currentHeadlinesPage: 1,
    isCommentsLoading: false,
    isUploadedCommentsLoading: false,
    isFeedsLoading: false,
    isTweetsLoading: false,
    isHeadlinesLoading: false,
    isRelevanceUpdating: false,
    isManuallyTogglingSarcasm: false,
    isShareReportSending: false,
    isInitialLoadOfCommentsForThisTopic: false,
    isInitialLoadOfUploadedCommentsForThisTopic: false, 
    isInitialLoadOfTweetsForThisTopic: false,
    isInitialLoadOfHeadlinesForThisTopic: false,
    sentiments: [],
    sources: [],
    feeds: { data: {}, count: null },
    tweets: { data: {}, count: null},
    headlines: {data: {}, count: null},
    isChartUpdating: false,
    csvData: '',
    isDownloadingCsv: false,
    csvArticleType: '',
    selectedTopicName: [],
    shareReportStatus:false,
    isFacebookConnected: false,
    isCheckingFacebookConnection: false,
    isUpdatingFacebookConnection: false,
    isSourceUpdating: false,
    selectedFilterFromDate: '',
    selectedFilterToDate: '',
    commentsAndTweetsMinimumSarcasmScore: 0,
    commentsAndTweetsMaximumSarcasmScore: 1,
    commentsAndTweetsMinimumSarcasmScoreDisplayed: 0,
    commentsAndTweetsMaximumSarcasmScoreDisplayed: 100,
    emotionCategoriesBeforeTogglingTweetOrComment: {},
    sentimentCategoriesBeforeTogglingTweetOrComment: {},
    relevanceFilterOption: RELEVANT_OPTION_VALUE
  };

  updateSelectedCharts = selectedCharts => {
    const { updateSelectedChartsList } = this.props.actions;
    this.setState(
      {
        isChartUpdating: true,
      },
      () => {
        updateSelectedChartsList(selectedCharts);
      },
    );
  };

  updateFeedsRelevant = props => {
    const { updateFeedsRelevant } = this.props.actions;
    const dashboardFilterDate = this.state.commentsFeedsFilterDate;
    props.dashboardFilterDate = dashboardFilterDate;
    this.setState({ isRelevanceUpdating: true });
    updateFeedsRelevant(props);
  };

  getCsvData = articleType => {
    this.setState(
      {
        isDownloadingCsv: true,
        csvArticleType: CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[articleType],
      },
      () => {
        const sources = this._getSourcesListFromLocalStorageOrGetDefaultList();
        this.props.actions.retrieveCsv({
          topicId: this.state.selectedTopicID,
          fromDate: this.state.commentsFeedsFilterDate.fromDate,
          toDate: this.state.commentsFeedsFilterDate.toDate,
          sources: sources.length
            ? sources.join(',').toLocaleLowerCase().trim()
            : 'all sources',
          type: CSV_ARTICLE_TYPE_BY_ARTICLE_TYPE[articleType],
        });
      },
    );
  };

  loadMoreComments = () => {
    this.setState(
      prevState => {
        return {
          currentCommentsPage: prevState.currentCommentsPage + 1,
          isCommentsLoading: true,
        };
      },
      () => {
         this.props.actions.retrieveAllComments(this.getCommentsQueryParams());
      },
    );
  };

  getCommentsQueryParams(){
    return {
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentCommentsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.selectedFilterFromDate 
        ?  this.state.selectedFilterFromDate 
        : this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.selectedFilterToDate 
        ?  this.state.selectedFilterToDate 
        : this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sources: this.state.sources,
      sortType: this.state.commentSortType,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    };
  }

  loadMoreUploadedComments = () => {
    this.setState(
      prevState => {
        return {
          currentUploadedCommentsPage: prevState.currentUploadedCommentsPage + 1,
          isUploadedCommentsLoading: true,
        };
      },
      () => {
         this.props.actions.retrieveAllUploadedComments(this.getUploadedCommentsQueryParams());
      },
    );
  };

  getUploadedCommentsQueryParams(){
    return {
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentUploadedCommentsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.selectedFilterFromDate 
        ?  this.state.selectedFilterFromDate 
        : this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.selectedFilterToDate 
        ?  this.state.selectedFilterToDate 
        : this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sortType: this.state.uploadedCommentsSortType,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    };
  }

  loadMoreTweets = () => {
    this.setState(
      prevState => {
        return {
          currentTweetsPage: prevState.currentTweetsPage + 1,
          isTweetsLoading: true,
        };
      },
      () => {
        this.props.actions.retrieveAllTweets({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentTweetsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: this.state.selectedFilterFromDate 
            ? this.state.selectedFilterFromDate 
            : this.state.commentsFeedsFilterDate.fromDate,
          toDate: this.state.selectedFilterToDate 
            ? this.state.selectedFilterToDate 
            : this.state.commentsFeedsFilterDate.toDate,
          sentiments: this.state.sentiments,
          sources: this.state.sources,
          sortType: this.state.tweetSortType,
          minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
          maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
          relevanceFilterOption: this.state.relevanceFilterOption 
        });
      },
    );
  };

  loadMoreHeadlines = () => {
    this.setState(
      prevState => {
        return {
          currentHeadlinesPage: prevState.currentHeadlinesPage + 1,
          isHeadlinesLoading: true,
        };
      },
      () => {
        this.props.actions.retrieveAllHeadlines({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentHeadlinesPage,
          pageLimit: PAGE_LIMIT,
          fromDate: this.state.selectedFilterFromDate 
            ? this.state.selectedFilterFromDate 
            : this.state.commentsFeedsFilterDate.fromDate,
          toDate: this.state.selectedFilterToDate 
            ? this.state.selectedFilterToDate 
            : this.state.commentsFeedsFilterDate.toDate,
          sentiments: this._changeSentimentLabelForHeadlinesAndTweets(this.state.sentiments),
          sources: this.state.sources,
          minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
          maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
      },
    );
  };

  getCategoryModalData = () => {
    this.props.actions.retrieveAllCategories();
  };

  getCompareData = (props = {}) => {
    this.props.actions.retrieveCompare({
      topicId: props.topicId,
      dateRangeFilterValue: props.dateRangeFilterValue,
      sources: props.selectedSource,
    });
  };

  loadMoreFeeds = () => {
    this.setState(
      prevState => {
        return {
          currentFeedsPage: prevState.currentFeedsPage + 1,
          isFeedsLoading: true,
        };
      },
      () => {
        this.props.actions.retrieveAllFeeds({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentFeedsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: this.state.selectedFilterFromDate
            ? this.state.selectedFilterFromDate 
            : this.state.commentsFeedsFilterDate.fromDate,
          toDate: this.state.selectedFilterToDate
            ? this.state.selectedFilterToDate 
            : this.state.commentsFeedsFilterDate.toDate,
          sentiments: this.state.sentiments,
          sources: this.state.sources,
          sortType: this.state.postSortType,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
      },
    );
  };

  displayUpdatePostSortTypeToastMessage = postSortSelection => {
    const postSortSelectionText = postSortSelection.toLowerCase();
    const toastMsg = `Sorting posts by ${postSortSelectionText}`;
    toast.info(toastMsg);
  }

  updatePostSortType = postSortSelection => {
    const postSortSelectionValue = postSortSelection[VALUE_KEY];
    const postSortType = POST_SORT_STATE_TO_VALUE_MAP[postSortSelectionValue];
    this.displayUpdatePostSortTypeToastMessage(postSortSelectionValue);
    this.setState(
      {
        postSortType:     postSortType,
        currentFeedsPage: 1,
        isFeedsLoading:   true
      },
      () => {
        this.requestSortedFeedsFromBackendUsingParamsFromState();
      });
  }

  displayUpdateCommentSortTypeToastMessage = commentSortSelection => {
    const commentSortSelectionText = commentSortSelection.toLowerCase();
    const toastMsg = `Sorting comments by ${commentSortSelectionText}`;
    toast.info(toastMsg);
  }

  updateCommentSortType = commentSortSelection => {
    const commentSortSelectionValue = commentSortSelection[VALUE_KEY];
    const commentSortType = COMMENT_SORT_STATE_TO_VALUE_MAP[commentSortSelectionValue];
    this.displayUpdateCommentSortTypeToastMessage(commentSortSelectionValue);
    this.setState(
      {
        commentSortType:  commentSortType,
        currentCommentsPage: 1,
        isCommentsLoading:   true
      },
      () => {
        this.requestSortedCommentsFromBackendUsingParamsFromState();
      });
  }

  displayUpdateUploadedCommentSortTypeToastMessage = uploadedCommentSortSelection => {
    const uploadedCommentSortSelectionText = uploadedCommentSortSelection.toLowerCase();
    const toastMsg = `Sorting uploaded comments by ${uploadedCommentSortSelectionText}`;
    toast.info(toastMsg);
  }

  updateUploadedCommentSortType = uploadedCommentSortSelection => {
    const uploadedCommentSortSelectionValue = uploadedCommentSortSelection[VALUE_KEY];
    const uploadedCommentsSortType = COMMENT_SORT_STATE_TO_VALUE_MAP[uploadedCommentSortSelectionValue];
    this.displayUpdateUploadedCommentSortTypeToastMessage(uploadedCommentSortSelectionValue);
    this.setState(
      {
        uploadedCommentsSortType:    uploadedCommentsSortType,
        currentUploadedCommentsPage: 1,
        isUploadedCommentsLoading:   true
      },
      () => {
        this.requestSortedUploadedCommentsFromBackendUsingParamsFromState();
      });
  }
  
  displayUpdateTweetSortTypeToastMessage = tweetSortSelection => {
    const tweetSortSelectionText = tweetSortSelection.toLowerCase();
    const toastMsg = `Sorting tweets by ${tweetSortSelectionText}`;
    toast.info(toastMsg);
  }

  updateTweetSortType = tweetSortSelection => {
    const tweetSortSelectionValue = tweetSortSelection[VALUE_KEY];
    const tweetSortType = COMMENT_SORT_STATE_TO_VALUE_MAP[tweetSortSelectionValue];
    this.displayUpdateTweetSortTypeToastMessage(tweetSortSelectionValue);
    this.setState(
      {
        tweetSortType:  tweetSortType,
        currentTweetsPage: 1,
        isTweetsLoading:   true
      },
      () => {
        this.requestSortedTweetFromBackendUsingParamsFromState();
      });
  }

  commentsFeedsFilterByDate = date => {
    const { selectedFilterFromDate, selectedFilterToDate } = this.state;
    if (selectedFilterFromDate || selectedFilterToDate) {
      this.setState({ 
        sentiments: [] 
      });
    }
    
    this.setState(
      {
        commentsFeedsFilterDate:     date,
        currentCommentsPage:         1,
        currentUploadedCommentsPage: 1,
        currentFeedsPage:            1,
        currentTweetsPage:           1,
        currentHeadlinesPage:        1,
        isCommentsLoading:           true,
        isUploadedCommentsLoading:   true,
        isTweetsLoading:             true,
        isHeadlinesLoading:          true,
        selectedFilterFromDate:      '',
        selectedFilterToDate:        '',
      },
      () => {
        this.requestFilteredCommentsFromBackendUsingParamsFromState();
        this.requestFilteredUploadedCommentsFromBackendUsingParamsFromState();
        this.requestFilteredHeadlinesFromBackendUsingParamsFromState();
        this.requestFilteredTweetsFromBackendUsingParamsFromState();
        this.requestFilteredFeedsFromBackendUsingParamsFromState();
      },
    );
  };

  requestFilteredCommentsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllComments({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentCommentsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sources: this.state.sources,
      sortType: this.state.commentSortType,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  requestFilteredUploadedCommentsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllUploadedComments({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentUploadedCommentsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sortType: this.state.uploadedCommentsSortType,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  requestFilteredHeadlinesFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllHeadlines({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentHeadlinesPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sentiments: this._changeSentimentLabelForHeadlinesAndTweets(this.state.sentiments),
      sources: this.state.sources,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  requestFilteredTweetsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllTweets({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentTweetsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sentiments: this._changeSentimentLabelForHeadlinesAndTweets(this.state.sentiments),
      sortType: this.state.tweetSortType,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  requestFilteredFeedsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllFeeds({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentFeedsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sources: this.state.sources,
      sortType: this.state.postSortType,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  requestSortedCommentsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllComments(this.getCommentsQueryParams());
  }

  requestSortedUploadedCommentsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllUploadedComments(this.getUploadedCommentsQueryParams());
  }

  requestSortedFeedsFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllFeeds({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentFeedsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.selectedFilterFromDate 
        ?  this.state.selectedFilterFromDate 
        : this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.selectedFilterToDate 
        ?  this.state.selectedFilterToDate 
        : this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sources: this.state.sources,
      sortType: this.state.postSortType,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  requestSortedTweetFromBackendUsingParamsFromState = () => {
    this.props.actions.filterAllTweets({
      topicId: this.state.selectedTopicID,
      currentPage: this.state.currentTweetsPage,
      pageLimit: PAGE_LIMIT,
      fromDate: this.state.selectedFilterFromDate 
        ?  this.state.selectedFilterFromDate 
        : this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.selectedFilterToDate 
        ?  this.state.selectedFilterToDate 
        : this.state.commentsFeedsFilterDate.toDate,
      sentiments: this.state.sentiments,
      sortType: this.state.tweetSortType,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    });
  }

  resetFilterInChart = () => {
    this.setState(
      prevState => {
        return {
          currentCommentsPage: 1,
          currentUploadedCommentsPage: 1,
          currentFeedsPage: 1,
          currentTweetsPage: 1,
          currentHeadlinesPage: 1,
          isCommentsLoading: true,
          isTweetsLoading: true,
          isHeadlinesLoading: true,
          isUploadedCommentsLoading: true,
          sentiments: [],
          sources: [],
          selectedFilterFromDate: '',
          selectedFilterToDate: '',
        };
      },
      () => {
        this.requestFilteredCommentsFromBackendUsingParamsFromState();
        this.requestFilteredUploadedCommentsFromBackendUsingParamsFromState();
        this.requestFilteredHeadlinesFromBackendUsingParamsFromState();
        this.requestFilteredTweetsFromBackendUsingParamsFromState();
        this.requestFilteredFeedsFromBackendUsingParamsFromState();
      },
    );
  };

  sendEmailReport = formData => {
    const { createShareReportFile } = this.props.actions;
    this.setState(
      {
        isShareReportSending: true,
      },
      () => {
        createShareReportFile(formData);
      },
    );
  };
  _displayCommentsFilteringToastMessage = filterObject => {
    const {date, value } = filterObject;
    if (date && value) {
      const sentimentType = value[0].charAt(0).toUpperCase() + value[0].toLowerCase().slice(1);
      const formattedDate = moment(date).format("LL");
      toast.info(`Filtering ${sentimentType} comments from ${formattedDate}`);
    }
  }

  setFilterDateRangeForAggregatedMonth = filterObject =>{
    const {date} = filterObject
    if (date) {
      const formattedFromDate = new Date(this.state.commentsFeedsFilterDate.fromDate)
      const formattedToDate = new Date(this.state.commentsFeedsFilterDate.toDate)
      const differenceInDays = Math.ceil(Math.abs(formattedToDate - formattedFromDate) / (1000 * 60 * 60 * 24))
      if (differenceInDays > DATE_RANGE_FOR_AGGREGATION){
        const formattedFirstDayOfTheMonth = filterObject.date.split('-').map(Number)
        const lastDayOfTheMonth = new Date(formattedFirstDayOfTheMonth[0],formattedFirstDayOfTheMonth[1], 1).toISOString().slice(0, 10)
        this.setState({
          selectedFilterFromDate: filterObject.date,
          selectedFilterToDate: lastDayOfTheMonth,
        })
      } else {
        this.setState({
          selectedFilterFromDate: filterObject.date,
          selectedFilterToDate: filterObject.date,
        })
      }
    } else {
      this.setState({
        selectedFilterFromDate: '',
        selectedFilterToDate: '',
      })
    } 
  }

  filter = filterObject => {
    this._displayCommentsFilteringToastMessage(filterObject);
    this.setFilterDateRangeForAggregatedMonth(filterObject);
    const sources = filterObject.sources
      ? filterObject.sources
      : this.state.sources;
    this.setState(
      prevState => {
        return {
          currentCommentsPage: 1,
          currentUploadedCommentsPage: 1,
          currentFeedsPage: 1,
          currentTweetsPage: 1,
          currentHeadlinesPage: 1,
          isCommentsLoading: true,
          isUploadedCommentsLoading: true,
          isTweetsLoading: true,
          isHeadlinesLoading: true,
          [filterObject.key]: filterObject.value,
        };
      },
      () => {
        let fromDateToUse = this.state.selectedFilterFromDate ? this.state.selectedFilterFromDate : this.state.commentsFeedsFilterDate.fromDate;
        let toDateToUse = this.state.selectedFilterToDate ? this.state.selectedFilterToDate : this.state.commentsFeedsFilterDate.toDate;
        this.props.actions.filterAllComments({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentCommentsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: fromDateToUse,
          toDate: toDateToUse,
          sentiments: this.state.sentiments,
          sources: sources,
          sortType: this.state.commentSortType,
          minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
          maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
        this.props.actions.filterAllUploadedComments({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentUploadedCommentsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: fromDateToUse,
          toDate: toDateToUse,
          sentiments: this.state.sentiments,
          sortType: this.state.uploadedCommentsSortType,
          minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
          maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
        this.props.actions.filterAllHeadlines({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentHeadlinesPage,
          pageLimit: PAGE_LIMIT,
          fromDate: fromDateToUse,
          toDate: toDateToUse,
          sentiments: this._changeSentimentLabelForHeadlinesAndTweets(this.state.sentiments),
          sources: sources,
          minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
          maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
        this.props.actions.filterAllTweets({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentTweetsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: fromDateToUse,
          toDate: toDateToUse,
          sentiments: this._changeSentimentLabelForHeadlinesAndTweets(this.state.sentiments),
          sortType: this.state.tweetSortType,
          minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
          maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
        this.props.actions.filterAllFeeds({
          topicId: this.state.selectedTopicID,
          currentPage: this.state.currentFeedsPage,
          pageLimit: PAGE_LIMIT,
          fromDate: fromDateToUse,
          toDate: toDateToUse,
          sentiments: this.state.sentiments,
          sources: sources,
          sortType: this.state.postSortType,
          relevanceFilterOption: this.state.relevanceFilterOption
        });
      },
    );
  };

  _changeSentimentLabelForHeadlinesAndTweets = (sentimentsArr) => {
    if (sentimentsArr.includes(NO_SPECIFIC_EMOTION)){
      return sentimentsArr.map(function(x){return x.replace(NO_SPECIFIC_EMOTION, NEUTRAL);});
    }
    return sentimentsArr; 
  }

  download = text => {
    const { commentsFeedsFilterDate, csvArticleType } = this.state;
    const articleType = ARTICLE_TYPE_BY_CSV_ARTICLE_TYPE[csvArticleType];
    const filename = `${articleType}_${commentsFeedsFilterDate.fromDate}_${commentsFeedsFilterDate.toDate}.csv`;
    const blob = new Blob([text], { type: 'text/csv' });
    FileSaver.saveAs(blob, filename);
    this.setState({
      csvData: '',
    });
  };

  _getSourcesListFromLocalStorageOrGetDefaultList = () => {
    const savedFilterData = JSON.parse(localStorage.getItem('dashboardFilter'));
    if (savedFilterData && savedFilterData.source) {
      return savedFilterData.source;
    }
    else {
      return [];
    }
  }

  _getSentimentsListFromLocalStorageOrGetDefaultList = () => {
    const savedFilterData = JSON.parse(localStorage.getItem('dashboardFilter'));
    if (savedFilterData && savedFilterData.FilterItems && savedFilterData.FilterItems.length) {
      return this._convertFilterItemsToArrayOfStrings(savedFilterData.FilterItems);
    }
    else {
      return ['all'];
    }
  }

  _convertFilterItemsToArrayOfStrings(FilterItems) {
    let sentiments = [];
    for (let i=0; i<FilterItems.length; i++) {
      let FilterItem = FilterItems[i];
      if (FilterItem.name === "all" && FilterItem.checked) {
        return ['all'];
      }
      else if (FilterItem.checked) {
        sentiments.push(FilterItem.value);
      }
    }
    return sentiments;
  }
  static contextType =GaContext

  componentDidMount() {
    this._checkFacebookConnectionWhenFirebaseUserInfoIsAvailable();

    this.props.actions.resetCommentsFeedsTweetsAndHeadlines();
    ReactGA.pageview('/dashboard')
    const { retrieveAllCharts } = this.props.actions;
    const savedFilterData = JSON.parse(localStorage.getItem('dashboardFilter'));
    const { commentsFeedsFilterDate } = this.state;
    if (savedFilterData && Object.keys(savedFilterData).length) {
      if (savedFilterData.dateRangeFilterValue) {
        commentsFeedsFilterDate['toDate'] = savedFilterData.dateRangeFilterValue.toDate;
        commentsFeedsFilterDate['fromDate'] = savedFilterData.dateRangeFilterValue.fromDate;
      }
      this.setState(
        {
          sources: this._getSourcesListFromLocalStorageOrGetDefaultList(),
          sentiments: this._getSentimentsListFromLocalStorageOrGetDefaultList(),
          commentsFeedsFilterDate,
        },
        () => {
          retrieveAllCharts();
        },
      );
    } else {
      retrieveAllCharts();
    }
  }

  _checkFacebookConnectionWhenFirebaseUserInfoIsAvailable() {
    const { checkFacebookConnection } = this.props.actions;
    const userEmail                   = getUserEmailFromLocalStorage();
    if (! userEmail) {
        this.props.history.push(getLoginRedirectUrl());
        return false;
    }
    else {
      this.setState({
        isCheckingFacebookConnection: true
      }, () => {
        checkFacebookConnection({
          resonance_user_email: userEmail
        });
      });
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      JSON.stringify(this.state.availableCharts) !==
      JSON.stringify(newProps.home.availableCharts)
    ) {
      const updatedChartData = JSON.parse(JSON.stringify(newProps.home.availableCharts)).map(
        chart => {
          chart['icon'] = chartIcons[chart.chartType.toLowerCase()];
          return chart;
        },
      );

      const filteredAndUpdatedChartData = this._filterOutUnimplementedCharts(updatedChartData);

      this.setState({
        availableCharts: [...filteredAndUpdatedChartData],
      });
    }

    if (newProps.home.updatedChartId.length && this.state.isChartUpdating) {
      const updatedChartList = newProps.home.updatedChartId.map(chart => chart.chartId);
      const trueCount = newProps.home.updatedChartId.filter(chart => chart.status === true);
      if (trueCount.length === updatedChartList.length) {
        toast.success('Chart(s) has been successfully added to the dashboard!');
      } else if (!trueCount.length) {
        toast.success('Chart(s) has been successfully removed from the dashboard!');
      } else {
        toast.success(
          'Chart(s) has been successfully added to and removed from the dashboard!',
        );
      }

      this.setState({
        isChartUpdating: false,
      });
    }

    if (this._receivedPropsSignalingReadyToUpdateDashboardForNewTopic(newProps)) {
      const selectedHeaderTopicData = newProps.home.headerTopicData;
      const selectedTopicID = newProps.home.activeTopic;
      this.retrieveAllCommentsAndFeeds(selectedHeaderTopicData, selectedTopicID);
      this.retrieveAllHeadlinesAndTweets(selectedHeaderTopicData, selectedTopicID);
      this.retrieveAllUploadedComments(selectedHeaderTopicData, selectedTopicID);
    }

    if (
      newProps.home.topicDropdown.length &&
      JSON.stringify(newProps.home.headerTopicData) !==
        JSON.stringify(this.state.topicDropdown)
    ) {
      this.setState({
        topicDropdown: newProps.home.headerTopicData,
      });
    }

    if (
      Object.keys(newProps.home.allFeeds).length &&
      JSON.stringify(this.state.feeds) !== JSON.stringify(newProps.home.allFeeds)
    ) {
      this.setState({
        isFeedsLoading: false,
        feeds: newProps.home.allFeeds,
      });
    }

    this._updateCommentRelatedStateIfNeeded(newProps);
    this._updateUploadedCommentRelatedStateIfNeeded(newProps);
    this._updateTweetRelatedStateIfNeeded(newProps);
    this._updateHeadlineRelatedStateIfNeeded(newProps);
    this._updateStateIfRelevanceUpdated(newProps);
    this._updateStateIfIsSarcasmManuallyToggledUpdated(newProps);

    if (newProps.home.sendShareReportSuccess && this.state.isShareReportSending) {
      toast.success('Report shared successfully.');
      this.setState({
        isShareReportSending: false,
      });
    }
    if (newProps.home.sendShareReportError && this.state.isShareReportSending) {
      toast.error('Failed to share report.');
      this.setState({
        isShareReportSending: false,
      });
    }
    if (
      JSON.stringify(newProps.home.activeTopicCompareData) !==
      JSON.stringify(this.state.activeTopicCompareData)
    ) {
      this.setState({
        activeTopicCompareData: newProps.home.activeTopicCompareData,
      });
    }
    if (
      newProps.home.selectedTopicName.length &&
      JSON.stringify(newProps.home.selectedTopicName) !==
        JSON.stringify(this.state.selectedTopicName)
    ) {
      this.setState({
        selectedTopicName: newProps.home.selectedTopicName,
      });
    }
    if (
      newProps.home.topicCompareData.length &&
      JSON.stringify(newProps.home.topicCompareData) !==
        JSON.stringify(this.state.topicCompareData)
    ) {
      this.setState({
        topicCompareData: newProps.home.topicCompareData,
      });

      if (
        (newProps.sendShareReportSuccess || newProps.sendShareReportError) &&
        this.state.isShareReportSending
      ) {
        this.setState({
          isShareReportSending: false,
        });
      }
    }

    if (this.hasPropsForCSVDownload(newProps)) {
      this.componentWillReceivePropsForCSVDownload(newProps);
    }

    this._setFacebookConnectionStateIfConnectionChecked(newProps);
    this._setFacebookConnectionStateIfConnectionUpdated(newProps);
  }

  _receivedPropsSignalingReadyToUpdateDashboardForNewTopic(newProps) {
    return newProps.home.activeTopic.length &&
      this._topicFromPropsDoesNotMatchTopicFromState(newProps) &&
      this._newTopicRetrievedJustNow(newProps) &&
      this._newActiveTopicSuccessfullyRetrieved(newProps);
  }

  _topicFromPropsDoesNotMatchTopicFromState(newProps) {
    return JSON.stringify(newProps.home.activeTopic) !== JSON.stringify(this.state.selectedTopicID);
  }

  _newTopicRetrievedJustNow(newProps) {
    return (!newProps.home.retrieveActiveTopicBegin && newProps.home.retrieveActiveTopicSucess);
  }

  _newActiveTopicSuccessfullyRetrieved(newProps) {
    return JSON.stringify(newProps.home.retrieveActiveTopicLastSuccessfulTopic) === JSON.stringify(newProps.home.activeTopic);
  }

  _updateCommentRelatedStateIfNeeded(newProps) {
    let updatedState = {};
    if (this._hasNewListOfCommentsReceivedFromProps(newProps)) {
      updatedState['isCommentsLoading']                   = false;
      updatedState['comments']                            = newProps.home.allComments;
      updatedState['isInitialLoadOfCommentsForThisTopic'] = false;
    }
    else if (this._didCommentsRequestComplete(newProps)) {
      updatedState['isCommentsLoading']                   = false;
      updatedState['isInitialLoadOfCommentsForThisTopic'] = false;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _hasNewListOfCommentsReceivedFromProps(newProps) {
    if (Object.keys(newProps.home.allComments).length &&
        JSON.stringify(this.state.comments) !== JSON.stringify(newProps.home.allComments)
      ) {
        return true;
      }
      else {
        return false;
      }
  }

  _didCommentsRequestComplete(newProps) {
    if ((newProps.home.retrieveCommentsSuccess
      || newProps.home.retrieveCommentsFailure) && this.state.isCommentsLoading) {
        return true;
    }
    else {
      return false;
    }
  }

  _updateUploadedCommentRelatedStateIfNeeded(newProps) {
    let updatedState = {};
    if (this._hasNewListOfUploadedCommentsReceivedFromProps(newProps)) {
      updatedState.isUploadedCommentsLoading                   = false;
      updatedState.uploadedComments                            = newProps.home.allUploadedComments;
      updatedState.isInitialLoadOfUploadedCommentsForThisTopic = false;
    }
    else if (this._didUploadedCommentsRequestComplete(newProps)) {
      updatedState.isUploadedCommentsLoading                   = false;
      updatedState.isInitialLoadOfUploadedCommentsForThisTopic = false;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _hasNewListOfUploadedCommentsReceivedFromProps(newProps) {
    return (
      Object.keys(newProps.home.allUploadedComments).length &&
      JSON.stringify(this.state.uploadedComments) !== JSON.stringify(newProps.home.allUploadedComments)
    );
  }

  _didUploadedCommentsRequestComplete(newProps) {
    return (
      (newProps.home.retrieveUploadedCommentsSuccess || newProps.home.retrieveUploadedCommentsFailure) && 
      this.state.isUploadedCommentsLoading
    );
  }

  _updateTweetRelatedStateIfNeeded(newProps) {
    let updatedState = {};
    if (this._hasNewListOfTweetsReceivedFromProps(newProps)) {
      updatedState['isTweetsLoading']                   = false;
      updatedState['tweets']                            = newProps.home.allTweets;
      updatedState['isInitialLoadOfTweetsForThisTopic'] = false;
    }
    else if (this._didTweetsRequestComplete(newProps)) {
      updatedState['isTweetsLoading']                   = false;
      updatedState['isInitialLoadOfTweetsForThisTopic'] = false;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _hasNewListOfTweetsReceivedFromProps(newProps) {
    if (Object.keys(newProps.home.allTweets).length &&
        JSON.stringify(this.state.tweets) !== JSON.stringify(newProps.home.allTweets)
      ) {
        return true;
      }
      else {
        return false;
      }
  }

  _didTweetsRequestComplete(newProps) {
    if ((newProps.home.retrieveTweetsSuccess
      || newProps.home.retrieveTweetsFailure) && this.state.isTweetsLoading) {
        return true;
    }
    else {
      return false;
    }
  }

  _updateHeadlineRelatedStateIfNeeded(newProps) {
    let updatedState = {};
    if (this._hasNewListOfHeadlinesReceivedFromProps(newProps)) {
      updatedState['isHeadlinesLoading']                   = false;
      updatedState['headlines']                            = newProps.home.allHeadlines;
      updatedState['isInitialLoadOfHeadlinesForThisTopic'] = false;
    }
    else if (this._didHeadlinesRequestComplete(newProps)) {
      updatedState['isHeadlinesLoading']                   = false;
      updatedState['isInitialLoadOfHeadlinesForThisTopic'] = false;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  _didHeadlinesRequestComplete(newProps) {
    if ((newProps.home.retrieveHeadlinesSuccess
      || newProps.home.retrieveHeadlinesFailure) && this.state.isHeadlinesLoading) {
        return true;
    }
    else {
      return false;
    }
  }

  _hasNewListOfHeadlinesReceivedFromProps(newProps) {
    if (Object.keys(newProps.home.allHeadlines).length &&
        JSON.stringify(this.state.headlines) !== JSON.stringify(newProps.home.allHeadlines)
      ) {
        return true;
      }
      else {
        return false;
      }
  }

  _updateStateIfRelevanceUpdated(newProps) {
    if (this.state.isRelevanceUpdating) {
      if (newProps.home.updateCommentsRelevantSuccess) {
        const commentAfterRelevanceUpdates = newProps.home.commentOrTweetAfterRelevanceUpdates;
        this._postRelevanceUpdateSuccessfulToastMessageAndResetIsRelevanceUpdatingState();
        this._updateChartsAfterUpdatingRelevanceOfCommentOrTweet(commentAfterRelevanceUpdates);
        this._updatePostCountsAfterCommentRelevanceUpdated(commentAfterRelevanceUpdates)
      }
      else if (newProps.home.updateTweetsRelevantSuccess || newProps.home.updateUploadedCommentsRelevantSuccess) {
        const tweetOrUploadedCommentAfterRelevanceUpdates = newProps.home.commentOrTweetAfterRelevanceUpdates;
        this._postRelevanceUpdateSuccessfulToastMessageAndResetIsRelevanceUpdatingState();
        this._updateChartsAfterUpdatingRelevanceOfCommentOrTweet(tweetOrUploadedCommentAfterRelevanceUpdates);
      }
      else if (newProps.home.updateFeedsRelevantSuccess) {
        const postAfterRelevanceUpdates = newProps.home.postAfterRelevanceUpdates;
        this._postRelevanceUpdateSuccessfulToastMessageAndResetIsRelevanceUpdatingState();
        this._updateChartsAfterUpdatingRelevanceOfPost(postAfterRelevanceUpdates);
      }
      else if (newProps.home.updateHeadlinesRelevantSuccess) {
        this._postRelevanceUpdateSuccessfulToastMessageAndResetIsRelevanceUpdatingState();
      }
      else if (newProps.home.updateCommentsRelevantFailure || newProps.home.updateHeadlinesRelevantFailure || newProps.home.updateFeedsRelevantFailure || 
        newProps.home.updateTweetsRelevantFailure || newProps.home.updateUploadedCommentsRelevantFailure) {
        toast.error(RELEVANCE_UPDATE_FAILURE_TOAST_MESSAGE);
        this.setState({
          isRelevanceUpdating: false,
        });
      }
    }
  }

  _postRelevanceUpdateSuccessfulToastMessageAndResetIsRelevanceUpdatingState() {
    toast.success(RELEVANCE_UPDATE_SUCCESSFUL_TOAST_MESSAGE);
    this.setState({
      isRelevanceUpdating: false,
    });
  }

  _updateChartsAfterUpdatingRelevanceOfCommentOrTweet(commentOrTweetAfterRelevanceUpdates) {
    let isUpdatedCommentWithinDateRange = this._doesUpdatedCommentOrTweetFallInFilterDateRange(commentOrTweetAfterRelevanceUpdates);
    if (isUpdatedCommentWithinDateRange) {
      const { updateChartForRelevanceUpdatesOfCommentOrTweet } = this.props.actions;
      const trendChartTimeUnit = this._getTrendChartTimeUnit();
      for (let chartId of CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE) {
        updateChartForRelevanceUpdatesOfCommentOrTweet(
          chartId,
          commentOrTweetAfterRelevanceUpdates,
          trendChartTimeUnit
        );
      }
    }
    toast.success(CHARTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE);
  }

  _updateChartsAfterUpdatingRelevanceOfPost(postAfterRelevanceUpdates) {
    const { updateChartForRelevanceUpdatesOfPost } = this.props.actions;
    for (let chartId of CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE) {
      updateChartForRelevanceUpdatesOfPost(
        chartId,
        postAfterRelevanceUpdates
      );
    }
    toast.success(CHARTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE);
  }

  _doesUpdatedCommentOrTweetFallInFilterDateRange(commentOrTweetAfterUpdates) {
    let dashboardFilter = JSON.parse(localStorage.getItem('dashboardFilter'));
    let filterDate = dashboardFilter.dateRangeFilterValue;
    let filterFromDateTime = moment(filterDate.fromDate + ' 00:00:00').format(DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT);
    let filterToDateTime = moment(filterDate.toDate + ' 23:59:59').format(DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT);
    let isUpdatedCommentWithinDateRange = moment(commentOrTweetAfterUpdates.datetime).isBetween(filterFromDateTime, filterToDateTime, undefined, []);
    return isUpdatedCommentWithinDateRange;
  }

  _getTrendChartTimeUnit() {
    let dashboardFilter = JSON.parse(localStorage.getItem('dashboardFilter'));
    let filterDate = dashboardFilter.dateRangeFilterValue;
    let fromDate = moment(filterDate.fromDate);
    let toDate = moment(filterDate.toDate);
    let differenceInDays = toDate.diff(fromDate, 'days');
    if (differenceInDays !== 0 && differenceInDays <= MAXIMUM_NUMBER_OF_DAYS_FOR_DAILY_TREND_CHARTS) {
      return DAY_UNIT;
    } else if (differenceInDays === 0) {
      return HOUR_UNIT;
    } else {
      return MONTH_UNIT;
    }
  }

  _updatePostCountsAfterCommentRelevanceUpdated(commentAfterRelevanceUpdates) {
    const { updatePostCountsForCommentRelevanceUpdates } = this.props.actions;
    updatePostCountsForCommentRelevanceUpdates(commentAfterRelevanceUpdates);
    toast.success(POST_COUNTS_UPDATED_AFTER_RELEVANCE_UPDATE_TOAST_MESSAGE);
  }

  _updateStateIfIsSarcasmManuallyToggledUpdated(newProps) {
    if (this.state.isManuallyTogglingSarcasm) {
      if (newProps.home.updateTweetsIsSarcasmManuallyToggledSuccess || newProps.home.updateUploadedCommentsIsSarcasmManuallyToggledSuccess) {
        const tweetOrUploadedCommentAfterToggling = newProps.home.commentOrTweetAfterToggling;
        toast.success(SARCASM_LABEL_UPDATED_MESSAGE);
        this.setState({
          isManuallyTogglingSarcasm: false,
        });
        this._updateChartsAfterTogglingSarcasm(tweetOrUploadedCommentAfterToggling);
      }
      else if (newProps.home.updateCrawledCommentsIsSarcasmManuallyToggledSuccess) {
        const commentAfterToggling = newProps.home.commentOrTweetAfterToggling;
        toast.success(SARCASM_LABEL_UPDATED_MESSAGE);
        this.setState({
          isManuallyTogglingSarcasm: false,
        });
        this._updatePostCountsAfterTogglingSarcasm(commentAfterToggling);
        this._updateChartsAfterTogglingSarcasm(commentAfterToggling);
      }
      else if (newProps.home.updateCrawledCommentsIsSarcasmManuallyToggledFailure || newProps.home.updateTweetsIsSarcasmManuallyToggledFailure || newProps.home.updateUploadedCommentsIsSarcasmManuallyToggledFailure) {
        toast.error(SARCASM_LABEL_NOT_UPDATED_MESSAGE);
        this.setState({
          isManuallyTogglingSarcasm: false,
        });
      }
    }
  }

  _updateChartsAfterTogglingSarcasm = (commentOrTweetAfterToggling) => {
    if (!commentOrTweetAfterToggling) {
      toast.error('Charts still do not reflect sarcasm toggling. Please refresh the page.');
      return;
    }
    const commentOrTweetId = this._returnSarcasmToggledCommentOrTweetId(commentOrTweetAfterToggling);
    const { updateChartForToggledSarcasticCommentOrTweet } = this.props.actions;
    const { emotionCategoriesBeforeTogglingTweetOrComment, sentimentCategoriesBeforeTogglingTweetOrComment } = this.state;
    const emotionCategoryBeforeTogglingTweetOrComment = emotionCategoriesBeforeTogglingTweetOrComment[commentOrTweetId];
    const sentimentCategoryBeforeTogglingTweetOrComment = sentimentCategoriesBeforeTogglingTweetOrComment[commentOrTweetId];
    const trendChartTimeUnit = this._getTrendChartTimeUnit();
    if (this._checkIfChartsUpdateNeededForCommentOrTweetToggledForSarcasm(commentOrTweetAfterToggling, emotionCategoryBeforeTogglingTweetOrComment, sentimentCategoryBeforeTogglingTweetOrComment)
      && this._doesUpdatedCommentOrTweetFallInFilterDateRange(commentOrTweetAfterToggling)) {
      for (let chartId of CHARTS_WHICH_NEED_ADJUSTMENT_FOR_SARCASM) {
        updateChartForToggledSarcasticCommentOrTweet(
          chartId,
          commentOrTweetAfterToggling,
          emotionCategoryBeforeTogglingTweetOrComment,
          sentimentCategoryBeforeTogglingTweetOrComment,
          trendChartTimeUnit
        );
      }
    }
    this._removeCorrespondingEmotionAndSentimentCategoriesFromStateAfterChartsUpdate(commentOrTweetId);
    toast.success('Charts now reflect sarcasm toggling');
  }

  _updatePostCountsAfterTogglingSarcasm = (commentAfterToggling) => {
    if (!commentAfterToggling) {
      toast.error(SARCASM_POST_COUNT_UPDATE_ERROR_MESSAGE);
      return;
    }
    const commentId = this._returnSarcasmToggledCommentOrTweetId(commentAfterToggling);
    const { updatePostCountsForToggledSarcasticComment } = this.props.actions;
    const { emotionCategoriesBeforeTogglingTweetOrComment, sentimentCategoriesBeforeTogglingTweetOrComment } = this.state;
    const emotionCategoryBeforeTogglingTweetOrComment = emotionCategoriesBeforeTogglingTweetOrComment[commentId];
    const sentimentCategoryBeforeTogglingTweetOrComment = sentimentCategoriesBeforeTogglingTweetOrComment[commentId];
    if (commentAfterToggling.relevance) {
      updatePostCountsForToggledSarcasticComment(
        commentAfterToggling.feedId,
        commentAfterToggling,
        emotionCategoryBeforeTogglingTweetOrComment,
        sentimentCategoryBeforeTogglingTweetOrComment
      );
    }
    toast.success('Post counts now reflect sarcasm toggling');
  }

  _returnSarcasmToggledCommentOrTweetId = (commentOrTweetAfterToggling) => {
    if (commentOrTweetAfterToggling.commentId) {
      return commentOrTweetAfterToggling.commentId;
    }
    else {
      return commentOrTweetAfterToggling.tweetId;
    }
  }

  _checkIfChartsUpdateNeededForCommentOrTweetToggledForSarcasm = (commentOrTweetAfterToggling, emotionCategoryBeforeTogglingTweetOrComment, sentimentCategoryBeforeTogglingTweetOrComment) => {
    return !((commentOrTweetAfterToggling.emotion.category === emotionCategoryBeforeTogglingTweetOrComment && commentOrTweetAfterToggling.sentiment.category === sentimentCategoryBeforeTogglingTweetOrComment) || !commentOrTweetAfterToggling.relevance);
  }

  _removeCorrespondingEmotionAndSentimentCategoriesFromStateAfterChartsUpdate = (commentOrTweetId) => {
    let { emotionCategoriesBeforeTogglingTweetOrComment, sentimentCategoriesBeforeTogglingTweetOrComment } = this.state;
    delete emotionCategoriesBeforeTogglingTweetOrComment[commentOrTweetId];
    delete sentimentCategoriesBeforeTogglingTweetOrComment[commentOrTweetId];
    this.setState({
      emotionCategoriesBeforeTogglingTweetOrComment: emotionCategoriesBeforeTogglingTweetOrComment,
      sentimentCategoriesBeforeTogglingTweetOrComment: sentimentCategoriesBeforeTogglingTweetOrComment
    });
  }

  updateCrawledCommentIsSarcasmManuallyToggledAndUpdateState = (props) => {
    this.setCommentOrTweetEmotionAndSentimentInfoToUseToUpdateChartsAfterSarcasmToggleSuccessful(props);
    this.callReduxActionToUpdateCrawledCommentIsSarcasmManuallyToggled(props);
  }
  
  updateTweetIsSarcasmManuallyToggledAndUpdateState = (props) => {
    this.setCommentOrTweetEmotionAndSentimentInfoToUseToUpdateChartsAfterSarcasmToggleSuccessful(props);
    this.callReduxActionToUpdateTweetIsSarcasmManuallyToggled(props);
  }

  updateUploadedCommentIsSarcasmManuallyToggledAndUpdateState = (props) => {
    this.setCommentOrTweetEmotionAndSentimentInfoToUseToUpdateChartsAfterSarcasmToggleSuccessful(props);
    this.callReduxActionToUpdateUploadedCommentIsSarcasmManuallyToggled(props);
  }

  setCommentOrTweetEmotionAndSentimentInfoToUseToUpdateChartsAfterSarcasmToggleSuccessful = (props) => {
    let { emotionCategoriesBeforeTogglingTweetOrComment, sentimentCategoriesBeforeTogglingTweetOrComment } = this.state;
    emotionCategoriesBeforeTogglingTweetOrComment[props.commentId] = props.emotionCategoryBeforeToggling;
    sentimentCategoriesBeforeTogglingTweetOrComment[props.commentId] = props.sentimentCategoryBeforeToggling;
    this.setState({
      emotionCategoriesBeforeTogglingTweetOrComment: emotionCategoriesBeforeTogglingTweetOrComment,
      sentimentCategoriesBeforeTogglingTweetOrComment: sentimentCategoriesBeforeTogglingTweetOrComment
    });
  }

  callReduxActionToUpdateCrawledCommentIsSarcasmManuallyToggled = (props) => {
    const { updateCrawledCommentsIsSarcasmManuallyToggled } = this.props.actions;
    updateCrawledCommentsIsSarcasmManuallyToggled({commentId: props.commentId, isSarcasmManuallyToggled: props.isSarcasmManuallyToggled});
  }

  callReduxActionToUpdateTweetIsSarcasmManuallyToggled = (props) => {
    const { updateTweetsIsSarcasmManuallyToggled } = this.props.actions;
    updateTweetsIsSarcasmManuallyToggled({commentId: props.commentId, isSarcasmManuallyToggled: props.isSarcasmManuallyToggled});
  }

  callReduxActionToUpdateUploadedCommentIsSarcasmManuallyToggled = (props) => {
    const { updateUploadedCommentsIsSarcasmManuallyToggled } = this.props.actions;
    updateUploadedCommentsIsSarcasmManuallyToggled({commentId: props.commentId, isSarcasmManuallyToggled: props.isSarcasmManuallyToggled});
  }

  hasPropsForCSVDownload(newProps) {
    if (
      newProps.home.csvData !== this.state.csvData &&
      newProps.home.retrieveCsvSuccess &&
      this.state.isDownloadingCsv
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  componentWillReceivePropsForCSVDownload(newProps) {
    this.setState(
      {
        csvData: newProps.home.csvData,
        isDownloadingCsv: false,
      },
      () => {
        if (this.state.csvData) {
          this.download(this.state.csvData);
        }
      },
    );
  }

  _filterOutUnimplementedCharts = (chartData) => {
    return chartData.filter(chart => ! UNIMPLEMENTED_CHART_IDS.includes(chart.chartId));
  }

  _setFacebookConnectionStateIfConnectionChecked(props) {
    if (this.state.isCheckingFacebookConnection && props.sources.check_facebook_connection_success) {
      this.setState({
         isCheckingFacebookConnection: false,
         isFacebookConnected: props.sources.check_facebook_connection_result
      });
    }
  }

  _setFacebookConnectionStateIfConnectionUpdated(props) {
      
     if (this.state.isUpdatingFacebookConnection && props.sources.update_facebook_connection_success) {
       this.setState({
         isUpdatingFacebookConnection: false,
         isFacebookConnected: true
       }, () => {
         const selectedHeaderTopicData = props.home.headerTopicData;
         const selectedTopicID = props.home.activeTopic;
         this.retrieveAllCommentsAndFeeds(selectedHeaderTopicData, selectedTopicID);
         this.retrieveAllHeadlinesAndTweets(selectedHeaderTopicData, selectedTopicID);
         this.retrieveAllUploadedComments(selectedHeaderTopicData, selectedTopicID);
          toast.success(FACEBOOK_CONNECTION_SUCCESS_MSG);
       });
     }
  }

  _isFacebookNotConnected() {
    return !this.state.isFacebookConnected && !this.state.isCheckingFacebookConnection && !this.isUpdatingFacebookConnection
  }

  _isFacebookConnectionOrSourceUpdating() {
    return this.state.isSourceUpdating || this.state.isCheckingFacebookConnection || this.isUpdatingFacebookConnection
  }

  setFacebookConnectionStateWhenConnectingToFacebook = (response) => {
    this.setState({
       isUpdatingFacebookConnection: true,
       facebookUserId: response.id,
       facebookAccessToken: response.accessToken
    });
  }

  _parseSarcasmScorePercentageToDecimal = (sarcasmScore) => {
    let sarcasmScoreDecimal = sarcasmScore / 100;
    return sarcasmScoreDecimal.toFixed(MAXIMUM_DECIMAL_PLACES_FOR_SARCASM_SCORE);
  }

  setCommentsAndTweetsSarcasmScoreFilter = (minimumSarcasmScore, maximumSarcasmScore) => {
    if (minimumSarcasmScore === '') {
      minimumSarcasmScore = 0;
    }
    if (maximumSarcasmScore === '') {
      maximumSarcasmScore = 100;
    }
    this.filterCommentsAndTweetsWithSarcasmScoreFilter(minimumSarcasmScore, maximumSarcasmScore);
  }

  filterCommentsAndTweetsWithSarcasmScoreFilter = (minimumSarcasmScore, maximumSarcasmScore) => {
    const resetCurrentPage = 1;
    const { selectedTopicID,
            sentiments, 
            commentSortType,
            uploadedCommentsSortType,
            tweetSortType, 
            selectedFilterFromDate, 
            selectedFilterToDate, 
            commentsFeedsFilterDate,
            relevanceFilterOption
          } = this.state;
    const minimumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(minimumSarcasmScore);
    const maximumSarcasmScoreDecimal = this._parseSarcasmScorePercentageToDecimal(maximumSarcasmScore);

    const commentsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sortType: commentSortType,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal,
      relevanceFilterOption: relevanceFilterOption
    };

    const uploadedCommentsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sortType: uploadedCommentsSortType,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal,
      relevanceFilterOption: relevanceFilterOption
    };

    const tweetsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sortType: tweetSortType,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: minimumSarcasmScoreDecimal,
      maxSarcasmScore: maximumSarcasmScoreDecimal,
      relevanceFilterOption: relevanceFilterOption
    };
    this.setState(
      {
        commentsAndTweetsMinimumSarcasmScore: minimumSarcasmScoreDecimal,
        commentsAndTweetsMaximumSarcasmScore: maximumSarcasmScoreDecimal,
        commentsAndTweetsMinimumSarcasmScoreDisplayed: minimumSarcasmScore,
        commentsAndTweetsMaximumSarcasmScoreDisplayed: maximumSarcasmScore,
        currentTweetsPage: resetCurrentPage,
        currentCommentsPage: resetCurrentPage,
        currentUploadedCommentsPage: resetCurrentPage,
      },
      () => {
        this.props.actions.filterAllComments(commentsQueryParams);
        this.props.actions.filterAllUploadedComments(uploadedCommentsQueryParams);
        this.props.actions.filterAllTweets(tweetsQueryParams);
      },
    );
  };

  handleRelevanceFilterSelection = e => {
    const relevanceOptionSelection = e.target.value;
    const resetCurrentPage = 1;
    const { 
      selectedTopicID,
      sources,
      sentiments, 
      commentSortType,
      uploadedCommentsSortType, 
      tweetSortType, 
      postSortType,
      selectedFilterFromDate, 
      selectedFilterToDate, 
      commentsFeedsFilterDate,
      commentsAndTweetsMinimumSarcasmScore,
      commentsAndTweetsMaximumSarcasmScore
      } = this.state;

    const commentsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sortType: commentSortType,
      sources: sources,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: relevanceOptionSelection
    };

    const uploadedCommentsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sortType: uploadedCommentsSortType,
      sources: sources,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: relevanceOptionSelection
    };

    const tweetsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sortType: tweetSortType,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: relevanceOptionSelection
    };

    const feedsQueryParams = {
      sentiments: sentiments,
      pageLimit: PAGE_LIMIT,
      currentPage: resetCurrentPage,
      topicId: selectedTopicID,
      sources: sources,
      sortType: postSortType,
      fromDate: selectedFilterFromDate || commentsFeedsFilterDate.fromDate,
      toDate: selectedFilterToDate || commentsFeedsFilterDate.toDate,
      minSarcasmScore: commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: relevanceOptionSelection
    };

    this.setState(
      {
        relevanceFilterOption: relevanceOptionSelection,
        currentTweetsPage: resetCurrentPage,
        currentCommentsPage: resetCurrentPage,
        currentUploadedCommentsPage: resetCurrentPage,
        currentFeedsPage: resetCurrentPage,
      },
      () => {
        this.props.actions.filterAllComments(commentsQueryParams);
        this.props.actions.filterAllUploadedComments(uploadedCommentsQueryParams);
        this.props.actions.filterAllTweets(tweetsQueryParams);
        this.props.actions.filterAllFeeds(feedsQueryParams);
      },
    );
  };

  retrieveAllCommentsAndFeeds (selectedHeaderTopicData, selectedTopicID) {
    const stateToSet = this.getStateForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedHeaderTopicData, selectedTopicID);
    const { commentSortType, postSortType } = this.state;
    const postDataForComments = this.getPostDataForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedTopicID, this.state.sentiments, commentSortType);
    const postDataForFeeds = this.getPostDataForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedTopicID, this.state.sentiments, postSortType);
    this.setState(stateToSet, () => {
      this.props.actions.retrieveAllComments(postDataForComments);
      this.props.actions.retrieveAllFeeds(postDataForFeeds);
    });
  }

  retrieveAllHeadlinesAndTweets (selectedHeaderTopicData, selectedTopicID) {
    const sentimentsForHeadlinesAndTweets = this._changeSentimentLabelForHeadlinesAndTweets(this.state.sentiments)
    const stateToSet = this.getStateForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedHeaderTopicData, selectedTopicID);
    const {tweetSortType} = this.state;
    const postDataForHeadlinesAndTweets = this.getPostDataForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedTopicID, sentimentsForHeadlinesAndTweets, tweetSortType);
    this.setState(stateToSet, () => {
      this.props.actions.retrieveAllHeadlines(postDataForHeadlinesAndTweets);
      this.props.actions.retrieveAllTweets(postDataForHeadlinesAndTweets);
    });
  }

  retrieveAllUploadedComments (selectedHeaderTopicData, selectedTopicID) {
    const stateToSet = this.getStateForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedHeaderTopicData, selectedTopicID);
    const { uploadedCommentsSortType, sentiments } = this.state;
    const postDataForUploadedComments = this.getPostDataForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedTopicID, sentiments, uploadedCommentsSortType);
    this.setState(stateToSet, () => {
      this.props.actions.retrieveAllUploadedComments(postDataForUploadedComments);
    });
  }

  getPostDataForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedTopicID, sentiments, sortType){
    const resetCurrentPage = 1;
    return {
      topicId: selectedTopicID,
      currentPage: resetCurrentPage,
      fromDate: this.state.commentsFeedsFilterDate.fromDate,
      toDate: this.state.commentsFeedsFilterDate.toDate,
      sources: this.state.sources,
      sentiments: sentiments,
      sortType: sortType,
      pageLimit: PAGE_LIMIT,
      minSarcasmScore: this.state.commentsAndTweetsMinimumSarcasmScore,
      maxSarcasmScore: this.state.commentsAndTweetsMaximumSarcasmScore,
      relevanceFilterOption: this.state.relevanceFilterOption
    };
  }

  getStateForRetrievingAllFeedsCommentsHeadlinesAndTweets(selectedHeaderTopicData, selectedTopicID) {
    const resetCurrentPage = 1;
    return {
        topicDropdown: selectedHeaderTopicData,
        selectedTopicID,
        isInitialLoadOfCommentsForThisTopic: true,
        isCommentsLoading: true,
        isInitialLoadOfUploadedCommentsForThisTopic: true,
        isUploadedCommentsLoading: true,
        isInitialLoadOfTweetsForThisTopic: true,
        isTweetsLoading: true,
        isInitialLoadOfHeadlinesForThisTopic: true,
        isHeadlinesLoading: true,
        currentCommentsPage: resetCurrentPage,
        currentUploadedCommentsPage: resetCurrentPage,
        currentFeedsPage: resetCurrentPage,
        currentTweetsPage: resetCurrentPage,
        currentHeadlinesPage: resetCurrentPage
    };
}

  render() {

    const {
      comments,
      uploadedComments,
      isCommentsLoading,
      isUploadedCommentsLoading,
      isTweetsLoading,
      isHeadlinesLoading,
      feeds,
      tweets,
      headlines,
      isFeedsLoading,
      selectedTopicID,
      activeTopicCompareData,
      topicCompareData,
      isShareReportSending,
      topicDropdown,
      availableCharts,
      selectedTopicName,
      isInitialLoadOfCommentsForThisTopic,
      isInitialLoadOfUploadedCommentsForThisTopic,
      isInitialLoadOfTweetsForThisTopic,
      isInitialLoadOfHeadlinesForThisTopic,
      sentiments,
      isDownloadingCsv,
      relevanceFilterOption,
      uploadedCommentsSortType
    } = this.state;
    const {
      updateCommentsRelevant,
      updateUploadedCommentsRelevant,
      updateTweetsRelevant,
      updateHeadlinesRelevant,
      retrieveAllCategories,
      retriveShareReportStatus,
      retrieveFeedDetails,
      filterAllComments,
      filterAllUploadedComments,
      filterAllTweets,
    } = this.props.actions;
    const availableSources = this.props.home.allSources.filter(source => source.selected);
    const { activeTab, shareReportStatus } = this.props.home;
    const topicJSONKeywords = topicDropdown.keywordsJSON ? topicDropdown.keywordsJSON : {};

    if (this._isFacebookNotConnected()) {

        return (<div className="home-default-page center-messages-container">
            <NoTopic
            title={FACEBOOK_LOGIN_WARNING_TITLE}
            message={FACEBOOK_LOGIN_WARNING_MSG}
            icons={['exclamation-circle']}
        >
            <FacebookConnect
                setFacebookConnectionStateWhenConnectingToFacebook={this.setFacebookConnectionStateWhenConnectingToFacebook}
            />
            </NoTopic>
        </div>);
    }

    if (this._isFacebookConnectionOrSourceUpdating()) {
        return (
            <div className="home-default-page center-messages-container">
                <p>{UPDATING_SOURCES_MSG}</p>
            </div>
        );
    }

    return (
      <div className="home-default-page">
        {activeTab && activeTab === 'dashboard' ? (
          <Dashboard
            cookies={this.props.cookies}
            comments={comments}
            uploadedComments={uploadedComments}
            headlines={headlines}
            sentiments={sentiments}
            feeds={feeds}
            tweets={tweets}
            postSortType={this.state.postSortType}
            dashboardCommentSortType={this.state.commentSortType}
            dashboardUploadedCommentsSortType={uploadedCommentsSortType}
            dashboardTweetSortType={this.state.tweetSortType}
            isCommentsLoading={isCommentsLoading}
            isUploadedCommentsLoading={isUploadedCommentsLoading}
            isTweetsLoading={isTweetsLoading}
            isHeadlinesLoading={isHeadlinesLoading}
            isDownloadingCsv = {isDownloadingCsv}
            isInitialLoadOfCommentsForThisTopic={isInitialLoadOfCommentsForThisTopic}
            isInitialLoadOfUploadedCommentsForThisTopic={isInitialLoadOfUploadedCommentsForThisTopic}
            isInitialLoadOfTweetsForThisTopic={isInitialLoadOfTweetsForThisTopic}
            isInitialLoadOfHeadlinesForThisTopic={isInitialLoadOfHeadlinesForThisTopic}
            loadMoreComments={() => this.loadMoreComments()}
            loadMoreUploadedComments={() => this.loadMoreUploadedComments()}
            loadMoreTweets={() => this.loadMoreTweets()}
            loadMoreHeadlines={() => this.loadMoreHeadlines()}
            updatePostSortType={(postSortSelection) => this.updatePostSortType(postSortSelection)}
            updateDashboardCommentSortType={(commentSortSelection) => this.updateCommentSortType(commentSortSelection)}
            updateDashboardUploadedCommentSortType={(uploadedCommentSortSelection) => this.updateUploadedCommentSortType(uploadedCommentSortSelection)}
            updateDashboardTweetSortType={(tweetSortSelection) => this.updateTweetSortType(tweetSortSelection)}
            filter={filterObj => this.filter(filterObj)}
            getCsvData={e => this.getCsvData(e)}
            sourcesFilter={availableSources}
            availableCharts={availableCharts}
            loadMoreFeeds={() => this.loadMoreFeeds()}
            filterFeedsCommentsByDate={value => this.commentsFeedsFilterByDate(value)}
            isFeedsLoading={isFeedsLoading}
            topicId={selectedTopicID.length ? [...selectedTopicID] : {}}
            topicKeywordsJSON={topicJSONKeywords}
            updateCommentsRelevant={e =>
              this.setState({ isRelevanceUpdating: true }, () => {
                updateCommentsRelevant(e);
              })
            }
            updateUploadedCommentsRelevant={e =>
              this.setState({ isRelevanceUpdating: true }, () => {
                updateUploadedCommentsRelevant(e);
              })
            }
            updateTweetsRelevant={e =>
              this.setState({ isRelevanceUpdating: true }, () => {
                updateTweetsRelevant(e);
              })
            }
            updateHeadlinesRelevant={e =>
              this.setState({ isRelevanceUpdating: true }, () => {
                updateHeadlinesRelevant(e);
              })
            }
            updateCrawledCommentsIsSarcasmManuallyToggled={e =>
              this.setState({ isManuallyTogglingSarcasm: true }, () => {
                this.updateCrawledCommentIsSarcasmManuallyToggledAndUpdateState(e);
              })
            }
            updateTweetsIsSarcasmManuallyToggled={e =>
              this.setState({ isManuallyTogglingSarcasm: true }, () => {
                this.updateTweetIsSarcasmManuallyToggledAndUpdateState(e);
              })
            }
            updateUploadedCommentsIsSarcasmManuallyToggled={e =>
              this.setState({ isManuallyTogglingSarcasm: true }, () => {
                this.updateUploadedCommentIsSarcasmManuallyToggledAndUpdateState(e);
              })
            }
            headerTopicData={this.props.home.headerTopicData}
            resetFilterInChart={e => this.resetFilterInChart()}
            updateFeedsRelevant={e => this.updateFeedsRelevant(e)}
            {...this.state}
            updateSelectedCharts={e => this.updateSelectedCharts(e)}
            retrieveShareReportMessage={() =>
              retriveShareReportStatus({ topicId: selectedTopicID })
            }
            sendEmailReport={e => this.sendEmailReport(e)}
            isShareReportSending={isShareReportSending}
            shareReportStatus={shareReportStatus}
            retrieveFeedDetails={e => retrieveFeedDetails(e)}
            retrieveAllComments={e => filterAllComments(e)}
            retrieveAllUploadedComments={e => filterAllUploadedComments(e)}
            retrieveAllTweets={e => filterAllTweets(e)}
            setCommentsAndTweetsSarcasmScoreFilter={this.setCommentsAndTweetsSarcasmScoreFilter}
            feedDetails={this.props.home.feedDetails}
            retrieveCategoriesBegin={this.props.home.retrieveCategoriesBegin}
            retrieveFeedsBegin={this.props.home.retrieveFeedsBegin}
            handleRelevanceFilterSelection={this.handleRelevanceFilterSelection}
            relevanceFilterOption={relevanceFilterOption}
          />
        ) : (
          <Compare
            cookies={this.props.cookies}
            sourcesFilter={availableSources}
            activeTopicCompareData={activeTopicCompareData}
            topicDropdown={topicDropdown}
            topicId={[...selectedTopicID]}
            topicCompareData={topicCompareData}
            categories={this.props.home.allCategories}
            filter={(value, key) => this.filter(value, key)}
            getCompareData={e => this.getCompareData(e)}
            selectedTopicNames={selectedTopicName}
            getCategories={e => retrieveAllCategories(e)}
            getCategoryModalData={e => this.getCategoryModalData(e)}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    sources: state.sources,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default withFirebase(connect(mapStateToProps, mapDispatchToProps)(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js